import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { PreLoaderComponent } from './pre-loader.component';

@NgModule({
  declarations: [PreLoaderComponent],
  exports: [PreLoaderComponent],
  imports: [CommonModule, MatProgressSpinnerModule],
})
export class PreLoaderModule {}
